export const fmtUSD = (n, digits = 2) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(n || 0));

export const fmtNum = (n, digits = 2) =>
  new Intl.NumberFormat("en-US", { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(n || 0));

export const fmtPct = (n, digits = 2) => `${Number(n || 0).toFixed(digits)}%`;

// Robustly parse any timestamp the backend / MT5 might hand us and return a Date
// in the browser's local time zone. Rules:
//   - "2026-09-02T17:43:00+00:00" / "…Z"     -> UTC (as declared)
//   - "2026-09-02T17:43:00"                  -> naïve ISO → treat as UTC
//   - "2026.09.02 20:42:02"                  -> MT5 broker format → treat as UTC
//   - anything else                          -> null (caller shows raw)
const parseSafe = (iso) => {
  if (!iso) return null;
  let s = String(iso).trim();
  if (/^\d{4}\.\d{2}\.\d{2} \d{2}:\d{2}:\d{2}$/.test(s)) {
    s = s.replace(/\./g, "-").replace(" ", "T") + "Z";
  } else if (/^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d+)?)?$/.test(s)) {
    s = s + "Z";
  }
  const d = new Date(s);
  return isNaN(d) ? null : d;
};

export const fmtDate = (iso) => {
  const d = parseSafe(iso);
  if (!d) return iso ? String(iso).slice(0, 10) : "—";
  return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "2-digit" });
};

export const fmtDateTime = (iso) => {
  const d = parseSafe(iso);
  if (!d) return iso ? String(iso) : "—";
  // toLocaleString uses the BROWSER's timezone by default. `timeZoneName: "short"`
  // appends the abbreviation ("CDT", "MDT", "EST", …) so it's unambiguous.
  return d.toLocaleString("en-US", {
    year: "numeric", month: "short", day: "2-digit",
    hour: "2-digit", minute: "2-digit", timeZoneName: "short",
  });
};

export const cx = (...a) => a.filter(Boolean).join(" ");
